import { ThemeSwitcher as SharedThemeSwitcher, useStoredThemePreference, type ThemePreference } from '@saas-pages/shared/public/app-shell'

const STORAGE_KEY = 'devdeck.theme'

export function useThemePreference() {
  return useStoredThemePreference(STORAGE_KEY)
}

export function ThemeSwitcher() {
  return <SharedThemeSwitcher storageKey={STORAGE_KEY} />
}

export type { ThemePreference }
